import React from "react";

const PageNotFound = () => (
  <div>
    <p>PageNotFound</p>
  </div>
);

export default PageNotFound;
